import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsCreateApiKeyCacheKeys: AllRouteEndpoints[] = ["/app_settings/create_api_key"];
